import { Suspense } from 'react';

import { useRouteHandleComponent } from '../useRouteHandleComponent';

/**
 * Renders the component named "Ordering" from the deepest matching route module's "handle" export.
 */
export function Ordering() {
  const result = useRouteHandleComponent({ name: 'Ordering' });

  if (result === undefined) {
    return null;
  }

  const { Component: RouteOrdering } = result;

  return (
    <div>
      <Suspense fallback={null}>
        <RouteOrdering />
      </Suspense>
    </div>
  );
}
